import project1Image from "../assets/projects/project1.png";
import project2Image from "../assets/projects/project2.png";
import project3Image from "../assets/projects/project3.png";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import EngineeringIcon from "@mui/icons-material/Engineering";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
export const stats = [
  {
    label: "Years Experience",
    value: "6+",
    icon: <EngineeringIcon sx={{ fontSize: 40, color: "#00CFC8" }} />,
  },
  {
    label: "Projects Completed",
    value: "20+",
    icon: <EmojiEventsIcon sx={{ fontSize: 40, color: "#00CFC8" }} />,
  },
  {
    label: "Happy Clients",
    value: "30+",
    icon: <EmojiPeopleIcon sx={{ fontSize: 40, color: "#00CFC8" }} />,
  },
];
export const projects = [
    {
      name: "Onboarding App By Yoma Bank",
      desc: "YOMA Onboarding App - Mobile onboarding with React Native.",
      img: project1Image,
      link: "https://play.google.com/store/search?q=onboarding%20app%20by%20yoma%20bank&c=apps&hl=en",
    },
    {
      name: "Sharmal | Real Estate & Car Agency Website",
      desc: "A modern, responsive web platform designed for Sharmal, a dual-purpose real estate and car dealership agency.",
      img: project2Image,
      link: "https://sharmal.net",
    },
    {
      name: "Fish Frenzy Game Admin Portal",
      desc: "A secure and intuitive admin dashboard built to manage and monitor the Fish Frenzy mobile game ecosystem.",
      img: project3Image,
      link: "https://fish-frenzy.vercel.app/",
    },
  ];
export const workExperience = [
  {
    role: "Team Lead - Software Engineer",
    company: "YOMA Bank",
    period: "Sep 2022 - Present",
    desc: "Leading OCR, mobile onboarding, and API integration.",
  },
  {
    role: "FullStack Developer",
    company: "SATHAPANA Co.Ltd",
    period: "Sep 2021 - 2022",
    desc: "Built dashboards, mobile apps and backend APIs.",
  },
  {
    role: "Founder - Project Manager",
    company: "NK Software House",
    period: "2016 - 2019",
    desc: "Developed websites, mobile apps, desktop software.",
  },
  {
    role: "Intern Software Engineer",
    company: "Huawei-Myanmar",
    period: "2019 - 2020",
    desc: "Built automation tools and dashboards.",
  },
  {
    role: "Founder",
    company: "NK Software House",
    period: "2016 - present",
    desc: "Founded and led NK Software House, delivering custom software solutions across web, mobile, and ICT solutions. Oversaw full project lifecycles including client communication, architecture, development, deployment, and maintenance. Specialized in automation tools, business dashboards, and cross-platform applications for SMEs and startups."
  },
];  
export const skills = {
  frontend: [
    "React",
    "React Native",
    "JavaScript",
    "TypeScript",
    "Material UI",
  ],
  backend: [".NET", "Spring Boot", "Node.js", "Java", "API Integration"],
  tools: ["SQL", "Oracle", "Power BI", "Firebase"],
  automation: ["OCR (Huawei/Misfit)", "Power Automate", "RPA", "Power Apps"],
};
  